import partner_1 from "../assets/partners/partner_1.png";
import proof from "../assets/proof.png";
import trading_img from "../assets/trading_img.png";

const HomePage = () => {
  return (
    <div className="bg-gray-50 text-gray-800 px-4 py-12 min-h-screen">
      <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-md">
        <div className="bg-white text-gray-800 font-[Manrope]">
          <main className="max-w-7xl mx-auto p-6">
            <section className="text-center my-12">
              <h1 className="text-4xl font-bold mb-4">Option Trade Ideas</h1>
              <h2 className="text-2xl text-gray-600 mb-4">Entries. Exits. Simple.</h2>
              <p className="text-lg">
                Two SMS live alerts daily: one at market open and one before close. Each includes
                suggested entry, stop loss, and target.
              </p>

              <img src={proof} />
            </section>

            <section className="my-16 text-center">
              <h2 className="text-2xl font-semibold mb-2">Latest Sneaky Order Flow</h2>
              <p>SOFI MAR1 2024 8C Detected 01/26/2024 13:56PM MST<br />
              Updated 1/28/2024 09:22 AM MST</p>
              <img
                src={trading_img}
                alt="Sneaky Order Flow"
                className="mx-auto mt-4 max-w-full h-auto"
              />
            </section>

            <section className="my-16 text-left">
              <h2 className="text-2xl font-semibold mb-4">Upcoming Earnings (delayed)</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>SOXL 37P buy write. AMD ITM 160C/170C due for pullback.</li>
                <li>INTC 55C and 42P OTM strangle from sneaky trader calling for flat.</li>
                <li>V 300C/270P, WDC 63C/68C spreads, KLAC 830C/780C spreads</li>
                <li>AXP 195C, BMI 125C ITM bearish, SPY flow: put leaning 4B MOC</li>
                <li>TSLA flat likely, IBM & NOW 800C, LRCX bearish</li>
              </ul>
            </section>

            <section className="text-center my-16">
              <h2 className="text-2xl font-semibold">Subscribe for Alerts & Coaching</h2>
              <p className="mb-4">Join now and get a 7-day free trial, then $50/month or $450/year</p>

              <div className="bg-white p-6 rounded-xl shadow-lg max-w-md mx-auto my-12">
      <h2 className="text-2xl font-semibold mb-4 text-center">
        Subscribe via PayPal
      </h2>
      <form
        action="https://www.paypal.com/cgi-bin/webscr"
        method="post"
        target="_top"
        className="space-y-4"
      >
        <input type="hidden" name="cmd" value="_s-xclick" />
        <input type="hidden" name="hosted_button_id" value="8A823UZ2AVC9A" />
        <input
          type="hidden"
          name="on0"
          value="Private Chat & Text Alert Subscription Options - Cancel Anytime!"
        />
        <label className="block text-gray-700 font-medium">
          Subscription Options
        </label>
        <select
          name="os0"
          className="w-full border rounded p-2"
          defaultValue="Option 1 - Free Trial for first 7 days then"
        >
          <option value="Option 1 - Free Trial for first 7 days then">
            Option 1 - Free Trial for 7 days, then $50/month
          </option>
          <option value="Option 2 - Free Trial for first 7 days then">
            Option 2 - Free Trial for 7 days, then $450/year
          </option>
        </select>
        <input type="hidden" name="currency_code" value="USD" />
        <div className="text-center">
          <input
            type="image"
            src="https://www.paypalobjects.com/en_US/i/btn/btn_subscribeCC_LG.gif"
            border="0"
            name="submit"
            alt="PayPal - The safer, easier way to pay online!"
          />
          <img
            alt=""
            border="0"
            src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
            width="1"
            height="1"
          />
        </div>
      </form>
    </div>
    
              <p className="mt-4">Or</p>
              <button asChild className="mt-2">
              
                <a href="https://billing.stripe.com/p/login/4gw8yDfU0f9m58YbII" className="flex items-center justify-center bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded">
                  <img src={partner_1} alt="Partner 1" className="mx-auto h-10 w-20" />
                </a>
              </button>
            </section>
          </main>

          <footer className="bg-gray-100 py-6 text-center text-sm">
            <div className="flex justify-center gap-4 mb-2">
              <a href="https://facebook.com/groups/652909564891054" target="_blank" rel="noreferrer">Facebook</a>
              <a href="https://twitter.com/aboutheoptions" target="_blank" rel="noreferrer">Twitter</a>
            </div>
            <p>&copy; 2016 It's All About The Options</p>
            <div className="flex justify-center gap-2 mt-2">
              <a href="/terms" className="hover:underline">Terms & Conditions</a>
              <a href="/privacy-policy" className="hover:underline">Privacy Policy</a>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
